<template>
  <span
    :class="[...classes, `icon--${color}`]"
    :style="{
      width: width ? width : null,
      minWidth: width ? width : null,
      height: height ? height : null,
      top: top ? top : null,
      fill: isNotStandardColor ? color : null,
    }"
    v-html="loading ? icons.singles.spinnerDrop : icon"
  ></span>
</template>

<script>
// Icons - Singles
import spinnerDrop from '@icons/interface/spinner-drop.svg';

export default {
  name: 'fs-button-icon',

  props: {
    icon: {},
    small: {
      type: Boolean,
      default: false,
    },
    width: String,
    height: String,
    // Colors
    // white
    color: String,
    top: String,

    loading: { type: Boolean, default: false },
    rightAligned: { type: Boolean, default: false },
  },

  data() {
    return {
      icons: {
        singles: {
          spinnerDrop,
        },
      },
    };
  },

  computed: {
    classes() {
      const classes = ['icon'];

      if (this.small) classes.push('icon--small');
      if (this.rightAligned) classes.push('icon--right-aligned');
      if (this.loading) classes.push('icon--spinning-svg');

      return classes;
    },
    isNotStandardColor() {
      return !(this.color === 'white' || this.color === 'dark-blue');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@styles/variables.scss';

// ============================================================================
// ============================================================================
// Icon
.icon {
  width: 1.14em;
  min-width: 1.14em;
  height: 1.14em;
  min-height: 1.14em;
  margin-right: 0.57em;
  margin-left: -0.0714em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: fill 0.15s ease-in-out;

  &--small {
    :deep(svg) {
      width: 1em;
      height: 1em;
    }
  }

  &--right-aligned {
    margin-right: -0.0714em;
    margin-left: 0.57em;
  }

  // Colors
  // Follows its label rather than naming a colour of its own: a button sets one colour for both,
  // and an icon that insists on white paints itself against an accent button instead of on it.
  // Where the label really is white — the dark buttons this was written for — nothing changes.
  &--white {
    :deep(svg) {
      fill: currentColor;
    }
  }
  &--dark-blue {
    :deep(svg) {
      fill: rgba($c-dark, 1);
    }
  }

  &--spinning-svg {
    :deep(svg) {
      animation: simpleSpinningAnimation;
      animation-duration: 0.45s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }
  }
}

@keyframes simpleSpinningAnimation {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
